import { Grid, Typography } from '@mui/material'
import React from 'react'
import SelectChipIndicator from '../SelectChipIndicator'
import PropTypes from 'prop-types'
import { formatThousands } from '../../../utils/RPQSUtils'

const IndicatorHeaderDialog = ({
    current={},
    previous={},
    status={},
    onStatusChange=() => {},
    unit='',
    offset=0,
    text='',
    options,
    readOnly=false,
}) => {
    return (
        <Grid
            container
            size={12}
        >
            <Grid container size={'grow'} alignItems={'end'}>
                {text &&
                    <Typography variant='h5'>
                        {text}
                    </Typography>
                }
            </Grid>
            <Grid
                container
                direction={'column'}
                sx={{ ml: 'auto' }}
                width={`calc(calc(100% - ${offset}px)/10)`}
                minWidth={100}
                justifyContent={'space-between'}
            >
                <Typography> {previous.year || '/'} </Typography>
                <Typography
                    variant='h5'
                >
                    {formatThousands(previous.value || 0)}
                </Typography>
            </Grid>
            <Grid
                container
                direction={'column'}
                sx={{ ml: 'auto' }}
                width={`calc(calc(100% - ${offset}px)/10)`}
                minWidth={100}
                justifyContent={'space-between'}
            >
                <Typography> {current.year || '/'} </Typography>
                <Typography
                    variant='h5'
                    color='#3548b0'
                    fontWeight={'bold'}
                >
                    {formatThousands(current.value || 0)}
                </Typography>
            </Grid>
            <Grid
                container
                width={`calc(calc(100% - ${offset}px)/5)`}
                direction={'column'}
            >
                <Grid
                    container
                    justifyContent={'end'}
                >
                    <SelectChipIndicator
                        right
                        indicatorStatus={status}
                        onChange={onStatusChange}
                        options={options}
                        readOnly={readOnly}
                    />
                </Grid>
                <Typography>
                    {unit}
                </Typography>
            </Grid>
        </Grid>
    )
}

IndicatorHeaderDialog.propTypes = {
    current: PropTypes.shape({
        year: PropTypes.string,
        value: PropTypes.number,
    }),
    previous: PropTypes.shape({
        year: PropTypes.string,
        value: PropTypes.number,
    }),
    status: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
        bgColor: PropTypes.string,
    }),
    onStatusChange: PropTypes.func,
    unit: PropTypes.string,
    offset: PropTypes.number,
    text: PropTypes.string,
    options: PropTypes.shape([]),
    readOnly: PropTypes.bool,
}

export default IndicatorHeaderDialog